export default {
  services: (state) => state.services,
  serviceDetails: (state) => state.serviceDetails,
};
